import { render, staticRenderFns } from "./bookingElementError.vue?vue&type=template&id=3898aad2&scoped=true"
import script from "./bookingElementError.vue?vue&type=script&lang=js"
export * from "./bookingElementError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898aad2",
  null
  
)

export default component.exports